import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import ReviewContent from 'AppComponents/BaseReview/Review/ReviewContent';
import Rating from 'AppComponents/Rating';

import './styles.scss';


const Review = ({ review, link, title }) => (
  <li styleName='review'>

    <h3><Link to={link}>{ title }</Link></h3>

    <blockquote>
      <ReviewContent
        title={review.title}
        time={review.modified}
        body={review.body}
        styleName='content'
      >
        <div><Rating rating={review.rating} /></div>
      </ReviewContent>
    </blockquote>

  </li>
);

Review.propTypes = {
  link: PropTypes.string.isRequired,
  review: PropTypes.shape({
    title: PropTypes.string,
    modified: PropTypes.string,
    body: PropTypes.string,
  }).isRequired,
  title: PropTypes.string.isRequired,
};

export default Review;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/User/components/Review/index.jsx